import Vue from 'vue'
import api from '../utils/api.js'

const INVALID_SUS_CODE= ['SUS-GA00002', 'SUS-GA00003', 'SUS-GA00004', 'SUS-GA00005'];

Vue.prototype.$tools = api;
//本地缓存
Vue.prototype.$storage = {
	getLogin() {
		try {
			return JSON.parse(sessionStorage.getItem("login-data"));
		} catch (e) {
			console.error(e);
			return null;
		}
	},
	setLogin(v) {
		try {
			sessionStorage.setItem("login-data", JSON.stringify(v));
		} catch (e) {
			console.error(e);
		}
	},
	getUser(k) {
		try {
			return JSON.parse(sessionStorage.getItem("user-data"));
		} catch (e) {
			console.error(e);
			return null;
		}
	},
	setUser(v) {
		try {
			sessionStorage.setItem("user-data", JSON.stringify(v));
		} catch (e) {
			console.error(e);
		}
	},
	clear() {
		sessionStorage.clear();
	}
};

Vue.prototype.$httpImg = function() {
	return new Promise((resolve, reject) => {
		this.$axios({
			url: "/susbase/common/authcode.jpg?" + Math.random(),
			method: 'get',
			responseType: 'arraybuffer',
			headers: {
				"hssessionid": sessionStorage.getItem('hssessionid') || ''
			}
		}).then((response) => {
			let base64Img = "data:image/png;base64," + btoa(new Uint8Array(response.data).reduce((data,
				byte) => data + String.fromCharCode(byte), ''));
			resolve(base64Img);
		}, (error) => {
			reject(error);
		});
	});
}
Vue.prototype.$http = function(request) {
	//处理请求体
	request = api.handleRequest(request);
	return new Promise((resolve, reject) => {
		this.$axios(request).then((response) => {
			//处理响应体
			response = api.handleResponse(response);
			if (INVALID_SUS_CODE.includes(response.data.susCode)) {
				this.$message({
					message: response.data.message || '访问超时，请重新登录！',
					type: 'warning',
				});
				window.location.href = window.location.origin + window.location.pathname;
			}
			resolve(response.data);
		}, (error) => {
			if (!!error && !!error.response && error.response.status == "401") {
				this.$message({
					message: '访问超时，请重新登录！',
					type: 'warning',
				});
				window.location.href = window.location.origin + window.location.pathname;
			} else {
				this.$message({
					message: "访问异常，请联系客服！",
					type: 'error',
				});
			}
			reject(error);
		});
	});
}

Vue.prototype.$jsonp = function(url) {
  return new Promise((resolve, reject) => {
    // 生成唯一的回调函数名
    const callback = `jsonpCallback_${Date.now()}`;

    // 创建 script 标签
    const script = document.createElement('script');

    // 构建完整的请求 URL
    const fullUrl = `${url}&callback=${callback}`;

    // 处理回调函数
    window[callback] = function(response) {
      resolve(response);
      // 清理 script 标签
      document.body.removeChild(script);
      delete window[callback];
    };

    // 设置 script 标签的 src 属性
    script.src = fullUrl;

    // 将 script 标签添加到页面
    document.body.appendChild(script);

    // 处理请求出错
    script.onerror = function() {
      reject(new Error('JSONP request failed'));
      document.body.removeChild(script);
      delete window[callback];
    };

    // 处理jsonp接口未返回callback数据无法删除script标签
    setTimeout(() => {
      document.body.removeChild(script);
    }, 5000);
  });
}



// WEBPACK FOOTER //
// ./src/utils/global.js